export default __webpack_public_path__ + "static/grass-area-085fc89249457ea5aa1c3d34e04b45f2.jpg";